<template lang="pug">
    include /@ibkr/lib.common/src/icon/arrow
    include /@ibkr/lib.common/src/icon/color

    div(class="expandable-button", v-click-outside="close")
        ib-button(@click="open", class="dark-grey-text fw-400 fs6 menu-body", :class="{ 'custom-button-red' : red }", :disabled="disabled")
            span(class="") {{ buttonText || title }}
            +icon-arrow-sort_down_filled
        div(v-if="showOptions", class="floating-options")
            ib-row
                ib-col
                    ib-button(@click="clickSelectAll", class="custom-button", :class="{ 'active-button' : selectAll }")
                        span(class="fw-700 dark-grey-text") {{ $t('select_all') }}
                        span(v-if="selectAll")
                            +icon-color-yes
            ib-row(v-for="(item, index) in tempItems", :key="item.key")
                ib-col
                    ib-button(@click="select(index)", class="custom-button", :class="{ 'active-button' : item.selected }") 
                        span(class="fw-300 grey-text") {{ $t(item.name) }}
                        span(v-if="item.selected")
                            +icon-color-yes
            ib-row(v-if="showError")
                ib-col
                    p(class="menu-error") {{ this.$t('choose_one') }}
            ib-row
                ib-col
                    ib-button-group(class="function-buttons")
                        ib-button(@click="reset", class="grey-text") Reset
                        ib-button(@click="apply", data-function="apply") Apply
</template>

<script>
export default {
    name: 'DropdownSelect',
    props: {
        // Unique identifier sent when apply is clicked along with items
        name: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            required: true
        },
        // The text of the menu-button
        title: {
            type: String
        },
        // Replace button text with value chosen
        showActive: {
            type: Boolean,
            default: false
        },
        // Styling for menu-button should be red
        red: {
            type: Boolean,
            default: false
        },
        // Menu button is disabled. Ex. User's can't choose MarketCaps for ETFs.
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            showOptions: false,
            selectAll: false,
            buttonText: '',
            tempItems: [],
            showError: false
        }
    },
    methods: {
        open() {
            if (!this.showOptions) {
                this.getOriginal();
                this.showOptions = true;
            } else {
                this.getOriginal();
                this.showOptions = false;
            }
        },
        close() {
            if(!this.showOptions) return;
            this.getOriginal();
            this.showOptions = false;
        },
        select(index) {
            this.tempItems[index].selected = !this.tempItems[index].selected;

            if (this.tempItems[index].selected) {
                this.showError = false;
            }

            if (this.selectAll) {
                this.selectAll = false;
            }

            // If all are selected, make selectedAll checked
            if (this.tempItems.filter(item => item.selected).length === this.tempItems.length) {
                this.selectAll = true;
            }
        },
        clickSelectAll() {
            if (this.selectAll) {
                this.tempItems.forEach(item => item.selected = false);
            } else {
                this.tempItems.forEach(item => {
                    if (!item.disabled) {
                        item.selected = true
                    }
                });
                this.showError = false;
            }
            this.selectAll = !this.selectAll;
        },
        apply() {
            // Trying to hit apply when nothing is selected displays an error.
            const numSelected = this.tempItems.filter(item => item.selected).length;
            if (numSelected === 0) {
                this.showError = true;
                return;
            }

            // Add any disabled items back to the list
            const submitList = this.tempItems.concat(this.items.filter(item => item.disabled));
            this.$emit('apply', this.name, submitList);
            if (this.showActive) this.showActiveItem();
            Vue.nextTick(() => this.close());
            // this.close();
        },
        reset() {
            // this.$emit('reset', this.tempItems);
            this.tempItems.forEach(item => item.selected = false);
            this.selectAll = false;
        },
        // This sets the user's original selected items. Used in cases where they don't hit apply & closes the menu.
        getOriginal() {
            // We don't want changes to immediately affect the prop since it is a reference. Thus a deep copy.
            this.tempItems = JSON.parse(JSON.stringify(this.items.filter(item => !item.disabled)));

            // Make error disappear if user clicked off when they had it.
            this.showError = false;

            // If all are selected (minus disabled items), make selectedAll checked
            if (this.tempItems.filter(item => item.selected).length === this.tempItems.length) {
                this.selectAll = true;
            } else {
                this.selectAll = false;
            }
        },
        showActiveItem() {
            // User doesn't pass in all, so a check needs to be done to see if all items are selected.
            if (this.tempItems.filter(item => item.selected).length === this.tempItems.length) {
                this.buttonText = this.$t('all');
                return;
            }

            for (let i = 0; i < this.tempItems.length; i++) {
                if (this.tempItems[i].selected) {
                    this.buttonText = this.$t(this.tempItems[i].name);
                    return;
                }
            }
        }
    },
    mounted() {
        this.getOriginal();
        if (this.showActive) this.showActiveItem();
    }
}
</script>

<style lang="less" scoped>
    @import "../less/globals.less";

    .expandable-button {
        position: relative;
        display: inline-block;

        @media (max-width:767px) {
            width: 100%;
        }
    }

    .floating-options {
        @media (max-width:767px) {
            width: 100%;
        }

        z-index: 1000;
        position: absolute;

        min-width: 15rem; /* 10 rem in design. Some root font difference. */
        left: 0px;
        top: 35 px;

        margin-top: 2px;
        padding: 8px 8px;
        border-radius: 0px;
        border-top: 3px solid @menu-popup-red;

        background-color: #fff;

        border-left: 1px solid rgba(0,0,0,.15);
        border-right: 1px solid rgba(0,0,0,.15);
        border-bottom: 1px solid rgba(0,0,0,.15);

        .function-buttons {
            display: flex;
            justify-content: center;
            margin: 0px;
            padding: 16px 0;

            border-top: 1px solid #d7d7d7;

            [data-function="apply"] {
                background-color: @apply-bg;
                color: white;
            }
        }

        &:after {
            display: inline-block;
            position: absolute;
            top: -7px;
            left: 0px;
            right: auto;
            margin: 0px 0px 0px 15px;
            border-right: 5px solid transparent;
            border-left: 5px solid transparent;
            border-bottom: 5px solid @menu-popup-red;
            content: "";
        }
    }
    .menu-error {
        text-align: center;
        color: @error-color;
        background-color: @error-bg;
        border-color: @error-border;
        border: 1px solid transparent;
        padding: 20px;
        margin: 8px;
    }
</style>